import React, { Component } from 'react';
import '../App.css';


class Wiktionary extends Component {
  render() {
    if (Object.keys(this.props.content).length > 0) {
      const results = this.props.content.map((content, i) =>
        <div key={i} className="WikiContent">
          <div className="WikiHeader">
            {content[0]}
          </div>
          <p>{content[1]}</p>
        </div>)


      /*var parsedContent = ""

      var index;
      for (index = 0; index < this.props.content.length; index++) {
        parsedContent += this.props.content[index].language.toUpperCase() + ": " + this.props.content[index].meaning.join('\n') + "\n"
      }

      if (parsedContent.length === 0) {
        parsedContent += "None"
      };*/
      //Makes the text red if it contains "vulgar"
      const divStyle = {
      };

      if(results.indexOf("vulgar") > -1) {
        divStyle.color = 'red';
      }
      

      return (
      <div style={divStyle} className="WiktionaryResult">
        <div>
          <div className="WikiHeader_top">Wiktionary:</div>
          {results}
        </div>
      </div>)
    } else {
      return (
        <div className="WiktionaryResult">
          <div>
            <div className="WikiHeader_top">Wiktionary:</div><p>Loading...</p>
          </div>
        </div>
      )
    }
  }
}

export default Wiktionary;



// WEBPACK FOOTER //
// ./client/src/Engines/Wiktionary.js